import {
  Button,
  SpaceBetween,
} from '@cloudscape-design/components';
import CarrierTable from 'components/Orders/package/carrierTable';
import { useShipping } from 'components/Orders/package/shippingProvider';
import PropTypes from 'prop-types';
import React from 'react';

export default function SelectRate({
  onPrev,
  onNext,
}) {
  const {
    selectedRates,
    isLoading,
    handleClearRates,
    handlePurchaseLabel,
  } = useShipping();

  const handlePrev = () => {
    handleClearRates();
    onPrev();
  };

  return (
    <SpaceBetween size="m">
      <CarrierTable />
      <div style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
        <Button onClick={handlePrev}>Back</Button>
        <Button variant="primary" loading={isLoading} onClick={() => handlePurchaseLabel({ onSuccess: onNext })}>
          {`Buy Label${selectedRates.length > 0 ? ` for $${selectedRates[0].price}` : ''}`}
        </Button>
      </div>
    </SpaceBetween>
  );
}
SelectRate.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};
